export const SET_GLOBAL_ACCOUNT_V2_SUMMARY = 'SET_GLOBAL_ACCOUNT_V2_SUMMARY';
